// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610211305/js/" + chunkId + "." + {"44":"4f205ca3","225":"0e128b6f","481":"f5f2f1e4","486":"5d976fd6","770":"7f4c9dee"}[chunkId] + ".0.04581942497866609.chunk.js";
};